import React from "react";
import CarSticker from "@/components/dashboard/CarSticker";
import CertificateCard from "@/components/dashboard/CertificateCard";
import ReelKit from "@/projects/social-media-kit/ReelKit";
import ReferralCard from "@/components/dashboard/ReferralCard";

export const MembershipGear = ({ user }) => {
    if (!user) return null;
    return (
        <section
            data-testid="membership-gear"
            className="rounded-lg border border-[#1f1f22] bg-[#080808] p-6 sm:p-8 lg:p-10"
        >
            <div className="mb-6 sm:mb-8">
                <span className="eviq-chip">Take EVIQ with you · Downloads</span>
                <h2 className="mt-4 font-editorial text-2xl leading-tight text-white sm:text-3xl md:text-4xl">
                    Your membership, made tangible.
                </h2>
                <p className="mt-2 max-w-xl text-sm text-zinc-500">
                    A window sticker, a printable certificate, a social reel kit sized for every
                    platform, and a friend link — everything you need to carry the movement past
                    the app.
                </p>
            </div>

            <div className="flex flex-col gap-4 sm:gap-5">
                <CarSticker user={user} />
                <ReelKit user={user} />
                <CertificateCard user={user} />
                <ReferralCard user={user} />
            </div>
        </section>
    );
};

export default MembershipGear;
